import(/* webpackMode: "eager", webpackExports: ["PoolsTable"] */ "/app/components/PoolsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProtocolLogo"] */ "/app/components/protocol-logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopPools"] */ "/app/components/TopPools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
